// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3252":"css/admin-app.6798","8779":"css/app.6798"}[chunkId] + ".css";
};